import React, { useEffect, useRef, useState } from "react";
import { store } from "app/store";

import InfoBanner from "app/DealMachineCore/snippets/InfoBanner";

const Container = ({
  id,
  children,
  style,
  fill,
  onResize,
  includeInfoBanner
}) => {
  const colors = store.getState().settings.colors;

  const containerRef = useRef();
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (containerRef.current && onResize) {
      const width = containerRef.current.offsetWidth;
      const height = containerRef.current.offsetHeight;
      if (size.width !== width || size.height !== height) {
        setSize({ width: parseInt(width), height: parseInt(height) });
        onResize(width, height);
      }
    }
  }, [onResize, size.width, size.height]);

  return (
    <div className={"deal-container-wrapper"}>
      {!!includeInfoBanner ? (
        <InfoBanner info_banner_type={includeInfoBanner} style={{ flex: 1 }} />
      ) : null}
      <div
        ref={containerRef}
        id={id}
        style={{
          backgroundColor: colors.background_color,
          ...style
        }}
        className={fill ? "deal-container-fill" : "deal-container"}
      >
        {children}
      </div>
    </div>
  );
};

export { Container };
